












































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
// @ts-ignore
import { AppConstants, emailRegex } from '@/app.constants';
// @ts-ignore
import { Utils } from '@/Utils';
import { store } from '../../store';
import ReferralCellRenderer from '../../components/ReferralCellRenderer.vue';
import EmailStatusCellRenderer from '@/components/EmailStatusCellRenderer.vue';
import { AgGridVue } from '@ag-grid-community/vue';

import {
    AllModules,
    GridOptions,
    IDatasource,
    IGetRowsParams,
    GridApi,
    ColDef,
    CellValueChangedEvent,
    IServerSideDatasource,
    IServerSideGetRowsParams,
    ValueFormatterParams,
    ValueFormatterService,
} from '@ag-grid-enterprise/all-modules';
// @ts-ignore
import Titlebar from '@/views/Admin/components/TitleBar.vue';
// @ts-ignore
import SelectHeader from '@/views/Admin/components/SelectHeader.vue';
import VueTagsInput from '@johmun/vue-tags-input';
import draggable from 'vuedraggable';
import { ConfigKeys, Setting, ResendReplyToRequest, FilterSelectionRequest, Role, SalesforceEmployerLocation } from '../../types';

declare const $: any;

interface SignUpWithReferrerRecord {
    id: number;
    firstName: string;
    lastName: string;
    cellPhone: string;
    emailAddress: string;
    referer: string;
    requestIpAddress: string;
    region: string;
    rating: number;
    timestamp: Date;
    employerName: string;
    ipAddressDetails: object;
    employerLocation: string;
    emailResponse: object;
    emailDateProcessed: Date;
    emailDateDropped: Date;
    emailDateDeferred: Date;
    emailDateDelivered: Date;
    emailDateBounced: Date;
    emailDateOpened: Date;
    emailDateClicked: Date;
    joinSurveyResponseOne: string[];
    joinSurveyResponseTwo: string[];
    joinSurveyResponseThree: string[];
    optedOut: boolean;
    shift: string;
    hireDate: Date;
    selectedLanguageCode: string;
    jobTitle: string;
    digitalCardURL: string;
    pronouns: string;
    salesforceEmployerLocationId: string;
    salesforceEmployerLocationName: string;
}

interface SignUpExport {
    results: SignUpWithReferrerRecord[];
    count: number;
}

interface FilterOptions {
    regions: string[];
    employers: string[];
    campaigns: string[];
    locals: string[];
}

interface Filter {
    campaigns?: string[];
    employers?: string[];
    regions?: string[];
    local?: string;
    showOtherEmployers?: boolean;
}

export interface GridColumnIdAndHeaderName {
    adminOnly?: boolean;
    headerName: string;
    colId: string;
    hide?: boolean;
}

interface Data {
    gridOptions: GridOptions;
    configs: Setting[];
    filterOpts: FilterOptions;
    filters: Filter;
    dataSource: IServerSideDatasource;
    selectedSignups?: SignUpWithReferrerRecord[];
    referrals: string[];
    campaigns: string[];
    accepableStorageState: number,
    tagEmail: string;
    form: SignUpWithReferrerRecord;
    mailRecipients: {
        text: string;
        ticlasses: string[];
    }[];
    emailTagValidation: {
        classes: string;
        rule: RegExp | Function;
        disableAdd?: boolean;
    }[];
    modules: typeof AllModules;
    totalCount: number;
    isSelectAllBtn: boolean;
    showSelectedAllBtnCheckMark: boolean;
    allGridIds: number[];
    contextColumns: GridColumnIdAndHeaderName[];
    exportAllColumns: boolean;
    isLoading: boolean;
}

interface CustomColDef extends ColDef {
    adminOnly?: boolean
}

const columnDefs: CustomColDef[] = [
    {
        field: 'firstName',
        checkboxSelection: false,
        cellRenderer: (params) => {
            const isOld = Utils.isRowOld(params) !== '';
            return `
                    <div class="flex items-center">
                        ${
                            isOld
                                ? `<div
                                        class="material-icons text-yellow-500 text-base mr-2"
                                        data-toggle="popover"
                                        data-trigger="hover"
                                        data-content="Signup is over 6 months old"
                                        >warning</div>`
                                : ''
                        }
                        <div>${params.value}</div>
                    </div>
                `;
        },
    },
    { field: 'lastName' },
    {
        field: 'timestamp',
        width: 140,
        type: 'dateColumn',
        sort: 'desc',
    },
    { field: 'pronouns', hide: true },
    {
        field: 'localNumber',
        width: 120,
        type: '',
    },
    {
        field: 'campaign',
        editable: true,
        cellEditor: 'agRichSelectCellEditor',
        cellEditorParams: {
            values: [],
        },
        cellRenderer: (params) => {
            return `<a href="/${params.data.campaign}" target="_blank">${params.data.campaign}</a>`;
        },
    },
    { field: 'region', width: 80 },
    {
        field: 'cellPhone',
        width: 120,
        type: 'phoneColumn',
        cellRenderer: (params) => {
            return (
                params.value &&
                `<a href='tel:${params.value}'>${params.valueFormatted}</a>`
            );
        },
    },
    {
        field: 'emailAddress',
        cellRenderer: (params) => {
            return (
                params.value &&
                `<a href='mailto:${params.value}'>${params.value}</a>`
            );
        },
    },
    { field: 'address', hide: true },
    { field: 'city', hide: true },
    { field: 'state', hide: true },
    { field: 'employeeId', hide: true },
    { field: 'zip', hide: true },
    {
        field: 'referrals',
        width: 90,
        cellRendererFramework: ReferralCellRenderer,
        colId: 'referralsCount',
    },
    { field: 'referer', adminOnly: true, hide: true },
    {
        field: 'pageSubmitted',
    },
    { field: 'rating', adminOnly: true, hide: true },
    { 
        field: 'employerLocation',
        valueGetter: (params) => {
            if (params.data?.employerLocation == "null" || params.data?.employerLocation == null) {
                if (params.data?.employerName?.includes('-')) {
                    return params.data?.employerName.split('-')[1];
                } else {
                    return '';
                }
            } 
            // Check if the employerLocation field contains remnants of the old JSON data we used to store there. If so, don't render it.
            else if (params.data?.employerLocation.includes("{") && params.data?.employerLocation.includes("}")) { 
                return '';
            } else {
                return params.data?.employerLocation;
            }
        },
    },
    { 
        field: 'employerName',
        cellRenderer: (params) => {
            return (params.data?.salesforceEmployerLocationId ? params.data?.salesforceEmployerLocationName : params.value);
        }, 
    },
    { field: 'department' },
    { field: 'jobTitle' },
    { field: 'hireDate', type: 'hireDate' },
    { field: 'joinSurveyResponseOne', headerName: 'Survey Answer 1' },
    { field: 'joinSurveyResponseTwo', headerName: 'Survey Answer 2' },
    { field: 'joinSurveyResponseThree', headerName: 'Survey Answer 3' },
    { field: 'joinSurveyResponseFour', headerName: 'Survey Answer 4' },
    { field: 'shift' },
    { field: 'referredByEmail' },
    {
        field: 'emailDateDelivered',
        adminOnly: true,
        hide: true,
        type: 'dateColumn',
    },
    {
        headerName: 'Email Status',
        adminOnly: true,
        hide: true,
        colId: 'emailStatus',
        valueGetter: () => {
            return 'hello';
        },
        cellRendererFramework: EmailStatusCellRenderer,
    },
    {
        field: 'emailDateOpened',
        adminOnly: true,
        hide: true,
        type: 'dateColumn',
    },
    {
        field: 'requestIpAddress',
        hide: true,
        adminOnly: true,
        headerName: 'IP Address',
    },
    {
        field: 'userAgent',
        adminOnly: true,
        hide: true,
        headerName: 'User Agent',
    },
    { field: 'optedOut' },
    { 
        field: 'selectedLanguageCode',
        headerName: 'Selected Language'
    },
    {
        field: 'digitalCardURL',
        cellRenderer: (params) => {
            return (
                params.value &&
                `<a href='${params.value}' target='_blank'>Digital Card PDF</a>`
            );
        },
    },
    { field: 'salesforceEmployerLocationId', hide: true },
    { field: 'salesforceEmployerLocationName'}

]

export default Vue.extend({
    name: 'admin',
    data(): Data {
        return {
            selectedSignups: [],
            configs: [],
            totalCount: 0,
            isSelectAllBtn: false,
            showSelectedAllBtnCheckMark: false,
            allGridIds: [],
            contextColumns: [],
            exportAllColumns: false,
            isLoading: false,
            accepableStorageState: new Date('2025-09-03:').getTime(),
            form: {
                id: 0,
                firstName: '',
                lastName: '',
                cellPhone: '',
                emailAddress: '',
                referer: '',
                requestIpAddress: '',
                region: '',
                rating: 0,
                timestamp: new Date(),
                employerName: '',
                ipAddressDetails: undefined,
                employerLocation: undefined,
                emailResponse: undefined,
                emailDateProcessed: new Date(),
                emailDateDropped: new Date(),
                emailDateDeferred: new Date(),
                emailDateDelivered: new Date(),
                emailDateBounced: new Date(),
                emailDateOpened: new Date(),
                emailDateClicked: new Date(),
                joinSurveyResponseOne: [],
                joinSurveyResponseTwo: [],
                joinSurveyResponseThree: [],
                optedOut: false,
                selectedLanguageCode: '',
                shift: '',
                hireDate: new Date(),
                jobTitle: '',
                digitalCardURL: '',
                pronouns: '',
                salesforceEmployerLocationId: undefined,
                salesforceEmployerLocationName: undefined
            },
            gridOptions: {
                rowMultiSelectWithClick: true,
                columnTypes: {
                    dateColumn: {
                        filter: 'agDateColumnFilter',
                        valueFormatter: (input) =>
                            input.value &&
                            moment
                                .utc(input.value)
                                .local()
                                .format('MM/DD/YYYY hh:mm a'),
                        comparator: (filterVal, cellVal) => {
                            const cellDate = moment(cellVal);
                            const filterDate = moment(filterVal);
                            if (cellDate.isBefore(filterDate)) {
                                return 1;
                            } else if (cellDate.isAfter(filterDate)) {
                                return -1;
                            } else {
                                return 0;
                            }
                        },
                    },
                    hireDate: {
                        valueFormatter: (input) =>
                            input.value &&
                            moment.utc(input.value).format('MM/DD/YYYY'),
                    },
                    phoneColumn: {
                        valueFormatter: (input) =>
                            input.value &&
                            input.value
                                .replace(/[^0-9]/g, '')
                                .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3'),
                    },
                },
                columnDefs: [
                    {
                        colId: 'select',
                        width: 48,
                        minWidth: 48,
                        maxWidth: 48,
                        checkboxSelection: true,
                        headerComponentFramework: SelectHeader,
                        headerComponentParams: {
                            toggleAllCheckboxBtn: () => {
                                // @ts-ignore
                                this.showSelectedAllBtnCheckMark = false;
                                setTimeout(() => {
                                    // @ts-ignore
                                    this.checkSetSelectionStatus();
                                });
                                // @ts-ignore
                                this.allGridIds = [];
                            },
                        },
                    },
                    ...columnDefs
                ],
                multiSortKey: 'ctrl',
                suppressMultiSort: false,
                enableServerSideFilter: false,
                pagination: true,
                rowModelType: 'serverSide',
                onPaginationChanged: () => {
                    const api: GridApi = this['gridOptions']['api'];
                    //@ts-ignore
                    //this.gridOptions.api.deselectAll();
                },
                enableFilter: false,
                onGridReady: this['onGridReady'],
                defaultColDef: {
                    sortable: true,
                    resizable: true,
                },
                rowSelection: 'multiple',
                context: {
                    parentComponent: this,
                },
                getRowNodeId: (d) => {
                    return d.id.toString();
                },
            },
            filterOpts: {
                regions: [],
                employers: [],
                campaigns: [],
                locals: []
            },
            filters: {
                employers: [],
                regions: [],
                campaigns: [],
                local: '',
                showOtherEmployers: false,
            },
            referrals: [],
            dataSource: {
                getRows: (params: IServerSideGetRowsParams) => {
                    const { startRow, endRow, sortModel, filterModel } =
                        params.request;
                    const api: GridApi = this['gridOptions']['api'];
                    api.showLoadingOverlay();

                    axios
                        .post<SignUpExport>(
                            `${process.env.VUE_APP_API_URI}/api/admin/signups/search`,
                            {
                                startRow,
                                endRow,
                                sortModel,
                                filterModel,
                                showAllRegions: this['showAllRegions'],
                                employerNames: this['filters']['employers'],
                                campaigns: this['filters']['campaigns'],
                                regions: this['filters']['regions'],
                                local: this['filters']['local']
                            }
                        )
                        .then((val) => {
                            let rowCount = undefined;
                            var totalCount = 0;

                            if (val.data.results.length < endRow - startRow) {
                                rowCount =
                                    api.getDisplayedRowCount() +
                                    val.data.results.length -
                                    1;
                            }

                            let locationIds = val.data.results.filter(r => r.salesforceEmployerLocationId !== null).map(r => r.salesforceEmployerLocationId);
                            // Only bother to look up each ID once (remove dupes)
                            locationIds = [...new Set(locationIds)];
                            axios
                                .post(
                                    `${process.env.VUE_APP_API_URI}/api/admin/signups/salesforceemployerlocations`,
                                    {
                                        salesforceEmployerLocationIds: locationIds
                                    }
                                )
                                .then((sflResults) => {
                                    val.data.results.forEach((r: SignUpWithReferrerRecord) => {
                                        
                                        sflResults.data.forEach((sflR: SalesforceEmployerLocation) => {
                                            if (r.salesforceEmployerLocationId === sflR.salesforceId) {
                                                r.salesforceEmployerLocationName = sflR.name;
                                            }
                                        });
                                    });
                                })
                                .catch((err) => {
                                    let errorMessage = '';
                                    if (
                                        err.response &&
                                        err.response.status ===
                                            AppConstants.HttpStatusCode.Unauthorized
                                    ) {
                                        errorMessage =
                                            'Unauthorized: please log out and back in';
                                    } else {
                                        errorMessage =
                                            "Couldn't retrieve the SF employer location data. Please try again later";
                                    }
                                    Utils.toastError(errorMessage);
                                    params.failCallback();
                                    api.hideOverlay();
                                });

                            params.successCallback(
                                val.data.results,
                                val.data.count
                            );
                            //@ts-ignore
                            this.totalCount = val.data.count;
                            api.hideOverlay();
                        })
                        .catch((err) => {
                            let errorMessage = '';
                            if (
                                err.response &&
                                err.response.status ===
                                    AppConstants.HttpStatusCode.Unauthorized
                            ) {
                                errorMessage =
                                    'Unauthorized: please log out and back in';
                            } else {
                                errorMessage =
                                    "Couldn't retrieve the data. Please try again later";
                            }
                            Utils.toastError(errorMessage);
                            params.failCallback();
                            api.hideOverlay();
                        });
                },
            },
            campaigns: [],
            tagEmail: '',
            mailRecipients: [],
            emailTagValidation: [
                {
                    classes: 'invalid',
                    rule: emailRegex,
                    // disableAdd: true
                },
            ],
            modules: AllModules,
        };
    },
    computed: {
        multipleRegions(): boolean {
            return this.filterOpts.regions.length > 1;
        },
        hasSelectedSignups(): boolean {
            return this.selectedSignups.length > 0;
        },
        isAdmin(): boolean {
            return (
                store?.token?.roles?.includes(Role.Admin) ||
                store?.token?.roles?.includes(Role.CampaignManager)
            );
        },
        userHasRegions(): boolean {
            return (
                store.token &&
                store.token.regions &&
                store.token.regions.length > 0
            );
        },
        defaultReplyToConfig(): Setting | undefined {
            return this.configs.find(
                (cfg) => cfg.configKey === ConfigKeys.DefaultReplyTo
            );
        },
        signerColumns(): GridColumnIdAndHeaderName[] {
            const signerColIds = ['timestamp', 'firstName', 'lastName'];
            return signerColIds
                .map(colId => this.contextColumns.find(c => c.colId === colId))
                .filter(Boolean) as GridColumnIdAndHeaderName[];
        },
        addressColumns(): GridColumnIdAndHeaderName[] {
            const addressColIds = ['address', 'city', 'state', 'zip'];
            return this.contextColumns.filter(c => addressColIds.includes(c.colId));
        },
        surveyPairs(): { question: GridColumnIdAndHeaderName; answer: GridColumnIdAndHeaderName }[] {
            const pairs: [string, string][] = [
                ['joinSurveyQuestionOne', 'joinSurveyResponseOne'],
                ['joinSurveyQuestionTwo', 'joinSurveyResponseTwo'],
                ['joinSurveyQuestionThree', 'joinSurveyResponseThree'],
                ['joinSurveyQuestionFour', 'joinSurveyResponseFour'],
            ];
            return pairs
                .map(([qId, aId]) => ({
                    question: this.contextColumns.find(c => c.colId === qId),
                    answer: this.contextColumns.find(c => c.colId === aId),
                }))
                .filter(pair => pair.question && pair.answer) as { question: GridColumnIdAndHeaderName; answer: GridColumnIdAndHeaderName }[];
        },
        otherColumns: {
            get(): GridColumnIdAndHeaderName[] {
                const excludedColIds = [
                    'timestamp', 'firstName', 'lastName',
                    'address', 'city', 'state', 'zip',
                    'joinSurveyQuestionOne', 'joinSurveyResponseOne',
                    'joinSurveyQuestionTwo', 'joinSurveyResponseTwo',
                    'joinSurveyQuestionThree', 'joinSurveyResponseThree',
                    'joinSurveyQuestionFour', 'joinSurveyResponseFour',
                ];
                return this.contextColumns.filter(c => !excludedColIds.includes(c.colId));
            },
            set(reordered: GridColumnIdAndHeaderName[]) {
                const excludedColIds = [
                    'timestamp', 'firstName', 'lastName',
                    'address', 'city', 'state', 'zip',
                    'joinSurveyQuestionOne', 'joinSurveyResponseOne',
                    'joinSurveyQuestionTwo', 'joinSurveyResponseTwo',
                    'joinSurveyQuestionThree', 'joinSurveyResponseThree',
                    'joinSurveyQuestionFour', 'joinSurveyResponseFour',
                ];
                // Find the indices in contextColumns where "other" items live
                const otherIndices: number[] = [];
                this.contextColumns.forEach((c, i) => {
                    if (!excludedColIds.includes(c.colId)) otherIndices.push(i);
                });
                // Replace those positions with the reordered items
                reordered.forEach((col, i) => {
                    this.$set(this.contextColumns, otherIndices[i], col);
                });
                this.setLocalStorageColumns(this.contextColumns);
            },
        },
    },
    mounted() {
        this.$nextTick(() => {
            $.fn.selectpicker.Constructor.BootstrapVersion = '4';
            $('.selectpicker').selectpicker('refresh');

            this.gridOptions.api.addEventListener(
                'rowSelected',
                this.getSelectedRows
            );

            this.loadGridState();

            const onStateChangeEvents = [
                'columnResized',
                'filterChanged',
                'displayedColumnsChanged',
                'sortChanged',
            ];
            onStateChangeEvents.forEach((e) =>
                this.gridOptions.api.addEventListener(e, this.onStateChanged)
            );
        });
        const lastExportedColumns = this.getLastExportedColumns();
        const defaultColumns = this.getDefaultExportColumns();
        if (lastExportedColumns.length === 0) {
            this.contextColumns = defaultColumns;
            this.setDefaultExportColumns();
        } else {
            // Restore saved columns in their saved order with saved hide state
            const restored: GridColumnIdAndHeaderName[] = [];
            lastExportedColumns.forEach((lastColumn) => {
                const defaultCol = defaultColumns.find(c => c.colId === lastColumn.colId);
                if (defaultCol) {
                    restored.push({ ...defaultCol, hide: lastColumn.hide });
                }
            });
            // Append any new columns not present in the saved list
            defaultColumns.forEach((defaultCol) => {
                if (!restored.find(c => c.colId === defaultCol.colId)) {
                    restored.push(defaultCol);
                }
            });
            this.contextColumns = restored;
        }
        // Signer fields are always included regardless of stored preferences
        const signerColIds = ['timestamp', 'firstName', 'lastName'];
        signerColIds.forEach(signerColId => {
            const col = this.contextColumns.find(c => c.colId === signerColId);
            if (col) col.hide = false;
        });
    },
    beforeMount() {
        this.validateStorageData();
        const campaigns = axios
            .get(`${process.env.VUE_APP_API_URI}/api/admin/weblinks`)
            .then((res) => {
                this.campaigns = [
                    '',
                    ...res.data
                        .map((camp) => camp.campaign)
                        .sort((a, b) => {
                            return a > b ? 1 : b > a ? -1 : 0;
                        }),
                ];

                const newColDefs = [...this.gridOptions.columnDefs];
                const campaignsCol: ColDef = newColDefs.find((colDef) => {
                    return (colDef as ColDef).field === 'campaign';
                });

                if (campaignsCol) {
                    campaignsCol.cellEditorParams.values = this.campaigns;
                }
            });
    },
    methods: {
        // Used to reset local storage values whenever a grid state change happens.
        validateStorageData() {
            const lastTimestamp = localStorage.getItem('ufcw-authcards-timestamp');
                if (!lastTimestamp || parseInt(lastTimestamp) < this.accepableStorageState) {
                    localStorage.removeItem('ufcw-authcards-grid-state');
                    // localStorage.removeItem(AppConstants.LocalStorageKeys.SIGNUP_EXPORT_COLUMNS);
                    localStorage.setItem('ufcw-authcards-timestamp', new Date().getTime().toString());
                }
        },
        onGridSelectionChange() {
            this.checkSetSelectionStatus();
        },
        checkSetSelectionStatus() {
            if (this.gridOptions.api.getSelectedRows().length >= 100) {
                // @ts-ignore
                this.isSelectAllBtn = true;
            } else {
                // @ts-ignore
                this.isSelectAllBtn = false;
            }
        },
        handleSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    axios
                        .put(
                            `${process.env.VUE_APP_API_URI}/api/signup`,
                            this.form
                        )
                        .then((_) => {
                            const row = this.gridOptions.api.getRowNode(
                                this.form.id.toString()
                            );

                            row.setData(this.form);
                            this.$modal.hide('sign-up-modal');
                        })
                        .catch((err) => {
                            let errorMessage = '';
                            if (err.response && err.response.status === 400) {
                                errorMessage =
                                    'Sorry, this link is unavailable';
                            } else if (err.response.status === 403) {
                                errorMessage =
                                    "You don't have permission to update this campaign";
                            } else {
                                console.log(err);
                                errorMessage =
                                    'Oops, an error occurred. Please try again later.';
                            }
                            Utils.toastError(errorMessage);
                        });
                }
            });
        },
        createDatasource(server) {
            return {
                // called by the grid when more rows are required
                getRows: function (params) {
                    // get data for request from server
                    var response = server.getData(params.request);

                    if (response.success) {
                        // supply rows for requested block to grid
                        params.successCallback(response.rows, response.lastRow);
                    } else {
                        // inform grid request failed
                        params.failCallback();
                    }
                },
            };
        },
        onRowDoubleClick({ data }) {
            this.$modal.show('sign-up-modal');
            this.form = data;
        },
        async selectAllEmployees() {
            if (!this.showSelectedAllBtnCheckMark) {
                this.showSelectedAllBtnCheckMark = true;

                const startRow = 0;
                const endRow = 0;
                const filterModel = this.gridOptions.api.getFilterModel();
                const sortModel = this.gridOptions.api.getSortModel();

                const response = await axios.post<number>(
                    `${process.env.VUE_APP_API_URI}/api/admin/signups/get-all-member-ids`,
                    {
                        startRow,
                        endRow,
                        sortModel,
                        filterModel,
                        showAllRegions: this['showAllRegions'],
                        employerNames: this['filters']['employers'],
                        campaigns: this['filters']['campaigns'],
                        regions: this['filters']['regions'],
                        local: this['filters']['local'],
                    }
                );
                // @ts-ignore
                this.allGridIds = response.data;
            } else {
                this.gridOptions.api.deselectAll();
                this.showSelectedAllBtnCheckMark = false;
                this.allGridIds = [];
            }
        },
        handleAddColumnExport(column: GridColumnIdAndHeaderName) {
            const signerColIds = ['timestamp', 'firstName', 'lastName'];
            if (signerColIds.includes(column.colId)) return;
            const col = this.contextColumns.find(
                (c) => c.colId == column.colId
            );
            col.hide = !col.hide;
            this.setLocalStorageColumns(this.contextColumns);
        },
        handleToggleSurveyPair(pair: { question: GridColumnIdAndHeaderName; answer: GridColumnIdAndHeaderName }) {
            const newHide = !pair.question.hide;
            const question = this.contextColumns.find(c => c.colId === pair.question.colId);
            const answer = this.contextColumns.find(c => c.colId === pair.answer.colId);
            if (question) question.hide = newHide;
            if (answer) answer.hide = newHide;
            this.setLocalStorageColumns(this.contextColumns);
        },
        getLastExportedColumns(): GridColumnIdAndHeaderName[] {
            const response = localStorage.getItem(
                AppConstants.LocalStorageKeys.SIGNUP_EXPORT_COLUMNS
            );

            var columns =
                response == 'undefined' || !response
                    ? []
                    : JSON.parse(response);

            return columns;
        },
        handleResetExportColumns() {
            this.setDefaultExportColumns();
            this.contextColumns = this.getDefaultExportColumns();
        },
        setDefaultExportColumns() {
            const cols = this.getDefaultExportColumns();

            localStorage.setItem(
                AppConstants.LocalStorageKeys.SIGNUP_EXPORT_COLUMNS,
                JSON.stringify(cols)
            );
        },
        getDefaultExportColumns(): GridColumnIdAndHeaderName[] {
            const cols = this.getColumnIdAndHeaderNames().filter(x => x.adminOnly !== true);
            

            // Inject survey quesitons from the parent campaign as exportable options
            cols.forEach((element) => {
                if (
                    element.colId == 'timestamp' ||
                    element.colId == 'firstName' ||
                    element.colId == 'lastName' ||
                    element.colId == 'localNumber' ||
                    element.colId == 'cellPhone' ||
                    element.colId == 'emailAddress' ||
                    element.colId == 'employerName'
                ) {
                    element.hide = false;
                } else {
                    element.hide = true;
                }
            });

            // Remove the column with colId 'optedOut'
            const index = cols.findIndex((col) => col.colId === 'optedOut');
            if (index !== -1) {
                cols.splice(index, 1);
            }

            cols.push({
                headerName: 'Unsigned Referrals',
                colId: 'unsignedReferrals',
                hide: true,
            });
            cols.push({
                headerName: 'Survey Question 1',
                colId: 'joinSurveyQuestionOne',
                hide: true,
            });
            cols.push({
                headerName: 'Survey Question 2',
                colId: 'joinSurveyQuestionTwo',
                hide: true
            });
            cols.push({
                headerName: 'Survey Question 3',
                colId: 'joinSurveyQuestionThree',
                hide: true
            });
            cols.push({
                headerName: 'Survey Question 4',
                colId: 'joinSurveyQuestionFour',
                hide: true
            });

            // Blacklisted columns
            const blacklistedColumns = [
            'referralsCount',
            ];

            return cols.filter(
                (col) => !blacklistedColumns.includes(col.colId)
            ).sort((a, b) => {
                return a.headerName > b.headerName
                    ? 1
                    : b.headerName > a.headerName
                    ? -1
                    : 0;
            });
        },
        setLocalStorageColumns(columns: GridColumnIdAndHeaderName): void {
            localStorage.setItem(
                AppConstants.LocalStorageKeys.SIGNUP_EXPORT_COLUMNS,
                JSON.stringify(columns)
            );
        },
        removeHiddenColumns(columns: GridColumnIdAndHeaderName[]) {
            return columns.filter((c) => c.hide == false);
        },
        convertColumnsToCommaSeperatedValue(
            columns: GridColumnIdAndHeaderName[]
        ): string {
            const cols = columns.map((column) => column.colId);
            return cols.join();
        },
        resetGridState() {
            localStorage.removeItem('ufcw-authcards-grid-state');
            this.gridOptions.columnApi.resetColumnState();
            this.gridOptions.columnApi.resetColumnGroupState();
            this.gridOptions.api.setSortModel([
                { colId: 'timestamp', sort: 'desc' },
            ]);
            this.gridOptions.api.setFilterModel(null);
        },

        loadGridState() {
            let gridState = localStorage.getItem('ufcw-authcards-grid-state');
            if (gridState != null) {
                let gridStateObj = JSON.parse(gridState) as any;
                this.gridOptions.columnApi.setColumnState(
                    gridStateObj.colState
                );
                this.gridOptions.columnApi.setColumnGroupState(
                    gridStateObj.groupState
                );
                this.gridOptions.api.setSortModel(gridStateObj.sortState);
                this.gridOptions.api.setFilterModel(gridStateObj.filterState);
            }
        },
        onStateChanged(e) {
            const gridState = {
                colState: this.gridOptions.columnApi.getColumnState(),
                groupState: this.gridOptions.columnApi.getColumnGroupState(),
                sortState: this.gridOptions.api.getSortModel(),
                filterState: this.gridOptions.api.getFilterModel(),
            };
            localStorage.setItem(
                'ufcw-authcards-grid-state',
                JSON.stringify(gridState)
            );
            localStorage.setItem(
                'ufcw-authcards-timestamp',
                new Date().getTime().toString()
            );
        },
        filter() {
            this.gridOptions.api.setServerSideDatasource(this.dataSource);
            this.$modal.hide('filter-modal');
        },
        // getDataSource() {
        //     this.gridOptions.api.getServerSideDatasource();
        // },
        getSelectedRows() {
            const selectedRows = this.gridOptions.api.getSelectedRows();
            const selectedIds = selectedRows.map((row) => row.id);
            this.selectedSignups = selectedRows;
        },
        handleExportAllColumns() {
            this.exportAllColumns = true;
            this.exportData();
        },
        openDeleteModal() {
            this.$modal.show('delete-signups-modal');
            this.getSelectedRows();
        },
        openExportModal() {
            this.$modal.show('export-signups-modal');
        },
        exportDigitalCards(){
            const api: GridApi = this['gridOptions']['api'];
            api.showLoadingOverlay();

            this.isLoading = true;
            const sortModel = this.gridOptions.api.getSortModel();
            const filterModel = this.gridOptions.api.getFilterModel();
            const selectedIds = this.getSelectedIds();

            axios
                .post(
                    `${process.env.VUE_APP_API_URI}/api/admin/export-cards`,
                    {
                        startRow: 0,
                        endRow: 0,
                        sortModel,
                        filterModel,
                        employerNames: this['filters']['employers'],
                        campaigns: this['filters']['campaigns'],
                        regions: this['filters']['regions'],
                        ids: selectedIds,
                    }, 
                    { responseType: 'blob' }
                )
                .then((res) => {
                    const blob = new Blob([res.data], {
                        type: res.headers['content-type'],
                    });
                    const blobUrl = URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.setAttribute('href', blobUrl);

                    if (res.headers['content-type'] == 'application/zip')
                    {
                      link.setAttribute(
                          'download',
                          `Digital Cards Export.zip`
                      );

                    }
                    else 
                    {
                      link.setAttribute(
                          'download',
                          `Digital Cards Export.pdf`
                      );
                    }
                    
                    link.innerHTML = 'Click Here to download';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    api.hideOverlay();  
                })
                .catch((err) => {
                    let errorMessage = '';
                    if (
                        err.response &&
                        err.response.status ===
                            AppConstants.HttpStatusCode.Unauthorized
                    ) {
                        errorMessage =
                            'Unauthorized: please log out and back in';
                    } else {
                        
                        errorMessage =
                            "Couldn't retrieve the data. Please try again later";
                    }
                    Utils.toastError(errorMessage);
                });
        },
        removeSelectColumn(columns: GridColumnIdAndHeaderName[]) {
            const index = columns.findIndex((b) => b.colId == 'select');
            columns.splice(index, 1);
            return columns;
        },
        getColumnIdAndHeaderNames() {
            const columns = this.gridOptions?.columnApi?.getAllColumns();
            const gridColumnIdAndHeaderNames: GridColumnIdAndHeaderName[] = [];
            columns.forEach((column) => {
                gridColumnIdAndHeaderNames.push({
                    headerName:
                        this.gridOptions.columnApi?.getDisplayNameForColumn(
                            column,
                            null
                        ),
                    colId: column.getColId(),
                    adminOnly: (column.getColDef() as CustomColDef).adminOnly,
                    hide: column.getColDef().hide,
                });
            });

            const gridColumns = this.removeSelectColumn(
                gridColumnIdAndHeaderNames
            );

            return gridColumnIdAndHeaderNames;
        },
        closeDeleteModal() {
            this.$modal.hide('delete-signups-modal');
        },
        getSelectedIds(): number[] {
            if (this.allGridIds.length > 0) {
                return this.allGridIds;
            } else {
                return this.gridOptions.api
                    .getSelectedRows()
                    .map((row) => row.id);
            }
        },
        exportData() {
            this.isLoading = true;
            const sortModel = this.gridOptions.api.getSortModel();
            const filterModel = this.gridOptions.api.getFilterModel();
            const selectedIds = this.getSelectedIds();
            //@ts-ignore
            this.setLocalStorageColumns(this.contextColumns);
            const signerColIds = ['timestamp', 'firstName', 'lastName'];
            const addressColIds = ['address', 'city', 'state', 'zip'];
            const pinnedColIds = [...signerColIds, ...addressColIds];
            const visibleColumns = this.removeHiddenColumns(this.contextColumns);
            const signerColumns = signerColIds
                .map(id => visibleColumns.find(c => c.colId === id))
                .filter(Boolean);
            const addressColumns = addressColIds
                .map(id => visibleColumns.find(c => c.colId === id))
                .filter(Boolean);
            const selectedColumns = [
                ...signerColumns,
                ...addressColumns,
                ...visibleColumns.filter(c => !pinnedColIds.includes(c.colId)),
            ];
            const columnNames =
                this.convertColumnsToCommaSeperatedValue(selectedColumns);

            axios
                .post<string>(
                    `${process.env.VUE_APP_API_URI}/api/admin/signups/export`,
                    {
                        startRow: 0,
                        endRow: 0,
                        sortModel,
                        filterModel,
                        employerNames: this['filters']['employers'],
                        campaigns: this['filters']['campaigns'],
                        regions: this['filters']['regions'],
                        ids: selectedIds,
                        columnNames,
                        exportAllColumns: this.exportAllColumns,
                    }
                )
                .then((val) => {
                    this.isLoading = false;
                    this.$modal.hide('export-signups-modal');
                    // the "\ufeff" below is a hack that makes it work with unicode
                    // See https://stackoverflow.com/questions/17879198/adding-utf-8-bom-to-string-blob for more info
                    const blob = new Blob(['\ufeff', val.data], {
                        type: 'application/csv',
                    });
                    const blobUrl = URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.setAttribute('href', blobUrl);

                    link.setAttribute('download', 'SignUps.csv');
                    link.innerHTML = 'Click Here to download';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch((err) => {
                    this.isLoading = false;
                    let errorMessage = '';
                    if (
                        err.response &&
                        err.response.status ===
                            AppConstants.HttpStatusCode.Unauthorized
                    ) {
                        errorMessage =
                            'Unauthorized: please log out and back in';
                    } else {
                        errorMessage =
                            "Couldn't retrieve the data. Please try again later";
                    }
                    Utils.toastError(errorMessage);
                });
        },
        deleteSignups(signups: SignUpWithReferrerRecord[]) {
            const selectedIds = this.getSelectedIds();

            axios
                .delete(`${process.env.VUE_APP_API_URI}/api/admin/signups`, {
                    data: {
                        Ids: selectedIds
                    },
                })
                .then((res) => {
                    const data = JSON.parse(res.config.data);
                    this.gridOptions.api.setServerSideDatasource(
                        this.dataSource
                    );
                    this.gridOptions.api.deselectAll();
                    this.allGridIds = [];
                })
                .then(() => {
                    this.closeDeleteModal();
                });
        },
        onPaginationChange() {
            Vue.nextTick(() => {
                $('[data-toggle="popover"]').popover();
            });
        },
        onGridReady() {
            this.gridOptions.api.setServerSideDatasource(this.dataSource);
        },
        openFilterModal() {
            this.$modal.show('filter-modal');
            this.getFilters();
        },
        getFilters() {
            const req: FilterSelectionRequest = {
                campaigns: this['filters']['campaigns'],
                regions: this['filters']['regions'],
                local: this['filters']['local'],
                showOtherEmployers: this['filters']['showOtherEmployers'],
            };

            axios
                .post(`${process.env.VUE_APP_API_URI}/api/admin/signups/employers`, req).then((res) => {
                    // Filter out null or empty employers
                    this.filterOpts.employers = res.data
                        .filter((emp) => emp)
                        .sort((a, b) => (a > b ? 1 : -1)).slice(0,500);

                    // Remove weird double spaces that can cause issues with opening the filter modal again after closing.
                    this.filterOpts.employers = this.filterOpts.employers.map(emp => emp.replace(/\s\s+/g, ' '));
        
                    if (!this.filters.employers.every(f => this.filterOpts.employers.includes(f))) {
                        this.filters.employers = [];
                    }
                });

            axios
                .post(`${process.env.VUE_APP_API_URI}/api/admin/signups/campaigns`, req)
                .then((res) => {
                    // Filter out null or empty campaigns
                    this.filterOpts.campaigns = res.data
                        .filter((camp) => camp)
                        .sort((a, b) => (a > b ? 1 : -1));

                    if (!this.filters.campaigns.every(f => this.filterOpts.campaigns.includes(f))) {
                        this.filters.campaigns = [];
                    }
                });

            axios
                .post(`${process.env.VUE_APP_API_URI}/api/admin/signups/locals`, req)
                .then((res) => {
                    // Filter out null or empty locals
                    this.filterOpts.locals = res.data
                        .filter((local) => local)
                        .sort((a, b) => (a > b ? 1 : -1));

                    if (!this.filterOpts.locals.includes(this.filters.local)) {
                        this.filters.local = '';
                    }
                });

            axios
                .get(`${process.env.VUE_APP_API_URI}/api/admin/signups/regions`)
                .then((res) => {
                    // Filter out null or empty regions
                    this.filterOpts.regions = res.data
                        .filter((region) => region)
                        .sort((a, b) => (a > b ? 1 : -1));
                });

            $('.selectpicker').selectpicker('refresh');
        },
        setEmployerFilter(e) {
            let opts = Array.from(e.target.selectedOptions);
            let employers = opts.map((opt) => (<HTMLInputElement>opt).value);

            this.filters.employers = employers;
        },
        setRegionFilter(e) {
            let opts = Array.from(e.target.selectedOptions);
            let regions = opts.map((opt) => (<HTMLInputElement>opt).value);
            this.filters.regions = regions;

            this.getFilters();
        },
        setCampaignFilter(e) {
            let opts = Array.from(e.target.selectedOptions);

            let campaigns = opts.map((opt) => (<HTMLInputElement>opt).value);

            this.filters.campaigns = campaigns;

            this.getFilters();
        },
        setLocalFilter(local: string) {
            this.filters.local = local;

            this.getFilters();
        },
        clearFilters() {
            this.filters.campaigns = [];
            this.filters.employers = [];
            this.filters.regions = [];
            this.filters.local = '';

            this.getFilters();

            $('.selectpicker').selectpicker('deselectAll');
        },
        openReferralsModal(id) {
            axios
                .get(`${process.env.VUE_APP_API_URI}/api/admin/referrals/${id}`)
                .then((res) => {
                    this.referrals = res.data;
                });

            this.$modal.show('referrals-modal');
        },
        cellValueChanged(params: CellValueChangedEvent) {
            if (
                params.colDef.field === 'campaign' &&
                params.oldValue !== params.newValue
            ) {
                axios
                    .put(
                        `${process.env.VUE_APP_API_URI}/api/admin/signup`,
                        params.data
                    )
                    .then((res) => {
                        params.node.setData(res.data);
                    });
            }
        },
        sendConfirmations() {
            const recordIds = this.gridOptions.api
                .getSelectedRows()
                .map((sup) => sup.id);

            const request: ResendReplyToRequest = {
                recipients: this.mailRecipients.map((tag) => tag.text),
                signupIds: recordIds,
            };

            axios
                .post(
                    `${process.env.VUE_APP_API_URI}/api/admin/signup/resend-replyto`,
                    request
                )
                .then((res) => {
                    this.mailRecipients = [];
                    this.$modal.hide('replyto-modal');
                    Utils.toastSuccess(
                        `Sent confirmations for ${res.data.length} signups`
                    );
                });
        },
        isRowOld: Utils.isRowOld,
    },
    components: {
        AgGridVue,
        Titlebar,
        VueTagsInput,
        draggable,
    },
    updated() {
        $('.selectpicker').selectpicker('refresh');
    },
});
